import { ChangeEvent } from "react";
import { OcRoleFilterSubtypeCollapseView } from "./role-filter-subtype-collapse-view";
import { useOcRoleFilterSubtypeCollapse } from "./use-role-filter-subtype-collapse";
import { OcRoleFilterItemData } from "oc/components/role-filter";

export type OcRoleFilterSubtypeCollapseProps = {
  opened: boolean;
  searchText: string;
  onSearchTextChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClearSearchText: () => void;
  handleFetchMore: () => void;
  handleClickItem: (item: OcRoleFilterItemData) => void;
  availableItems: OcRoleFilterItemData[];
  selectedItems: OcRoleFilterItemData[];
  editable?: boolean;
  dataTotal: number | undefined; // The reason I'm not using '?', is to make it clear that is a mandatory prop.
  noCode?: boolean;
  type?: string; //TODO f better name, this is only used for id
} & (
  | {
      isCheckbox: true;
      handleCheckAll: () => void;
    }
  | {
      isCheckbox?: false;
      handleCheckAll?: () => void;
    }
);

export const OcRoleFilterSubtypeCollapse: React.FC<
  OcRoleFilterSubtypeCollapseProps
> = ({
  availableItems,
  editable = true,
  dataTotal = 0,
  noCode,
  type = "non-specified",
  ...props
}) => {
  const processedData = useOcRoleFilterSubtypeCollapse({
    availableItems,
    dataTotal,
    type,
    editable,
    noCode,
  });

  return (
    <OcRoleFilterSubtypeCollapseView
      {...props}
      {...processedData}
      availableItems={availableItems}
      editable={editable}
    />
  );
};
